import { ReactNode } from "react";
import { Link } from "react-router-dom";

/** Shared layout + typography for the static legal pages. */
const LegalShell: React.FC<{ title: string; updated: string; children: ReactNode }> = ({
  title,
  updated,
  children,
}) => (
  <div className="mx-auto max-w-3xl">
    <h1 className="font-display text-4xl font-semibold text-ink">{title}</h1>
    <p className="mt-1 text-sm text-ink/45">Last updated: {updated}</p>
    <div className="mt-6 space-y-6 leading-relaxed text-ink/75">{children}</div>

    <div className="mt-10 flex flex-wrap gap-x-5 gap-y-1 border-t border-primary-100 pt-6 text-sm text-ink/50">
      <Link to="/privacy" className="hover:text-primary-600">
        Privacy Policy
      </Link>
      <Link to="/sms-policy" className="hover:text-primary-600">
        SMS Policy
      </Link>
      <Link to="/terms" className="hover:text-primary-600">
        Terms &amp; Conditions
      </Link>
    </div>
  </div>
);

/** A titled section within a legal page. */
export const Section: React.FC<{ heading: string; children: ReactNode }> = ({ heading, children }) => (
  <section className="space-y-2">
    <h2 className="font-display text-xl font-semibold text-ink">{heading}</h2>
    {children}
  </section>
);

export default LegalShell;
